import { useTranslation } from 'react-i18next';
import type { SplitStatus } from '@/shared/types/api/splits';
import { StatusChip } from '@/shared/ui/chips/StatusChip';

type SplitStatusChipProps = {
  status: SplitStatus;
  className?: string;
};

// Color mapping:
// - DRAFT: gray (editable by the user, not yet submitted)
// - IN_PROGRESS: blue (admin has taken over, being processed)
// - DELIVERED: green (finalised / delivered)
const SPLIT_STATUS_STYLES: Record<SplitStatus, string> = {
  DRAFT: 'bg-slate-100 text-slate-700 border-slate-200',
  IN_PROGRESS: 'bg-sky-100 text-sky-800 border-sky-200',
  DELIVERED: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

export const FeaturesSplitsStatusChip = ({ status, className }: SplitStatusChipProps) => {
  const { t } = useTranslation('splits');
  return (
    <StatusChip
      toneClass={SPLIT_STATUS_STYLES[status]}
      label={t(`status.${status}`)}
      className={className}
    />
  );
};
